
<div class="container" *ngIf="labelTitulo">
  <div class="row">
    <div class="col">
      <h3>{{labelTitulo}}</h3>
    </div>
  
    <div class="col-auto">
      <button class="btn btn-primary" type="button" (click)="exportarDados()" placement="bottom"
           ngbTooltip="Exporta um arquivo CSV." [disabled]="!datasValidas">
        <i class="fa fa-file"></i> Download</button> 
    </div>
  </div>

  <div class="row">

      <div class="bn-form-group col-md-5">
        <label for="dataEmissaoDaFichaInicial">{{ labelDataInicio }}:</label>
        <bn-datepicker name="dataInicio" [(ngModel)]="dataInicio" [ngModelOptions]="{standalone: true}" (ngModelChange)="validarDatas()" >
        </bn-datepicker>
      </div>

      <div class="bn-form-group col-md-5">
        <label for="dataEmissaoDaFichaFinal">{{ labelDataFim }}:</label>
        <bn-datepicker name="dataFim" [(ngModel)]="dataFim" [ngModelOptions]="{standalone: true}" (ngModelChange)="validarDatas()" >
        </bn-datepicker>
      </div>
  </div>

  <div class="row" *ngIf="msgErro" style="color: red; margin-top: 5px;">
    <div class="bn-form-group col-md-5">
     {{ msgErro }}
  </div>
  </div>

</div>
